/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Registration200ResponseData } from './Registration200ResponseData'
import {
  Registration200ResponseDataFromJSON,
  Registration200ResponseDataFromJSONTyped,
  Registration200ResponseDataToJSON,
} from './Registration200ResponseData'

/**
 *
 * @export
 * @interface Registration200Response
 */
export interface Registration200Response {
  /**
   *
   * @type {boolean}
   * @memberof Registration200Response
   */
  status: boolean
  /**
   *
   * @type {Registration200ResponseData}
   * @memberof Registration200Response
   */
  data: Registration200ResponseData
}

/**
 * Check if a given object implements the Registration200Response interface.
 */
export function instanceOfRegistration200Response(
  value: object
): value is Registration200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function Registration200ResponseFromJSON(
  json: any
): Registration200Response {
  return Registration200ResponseFromJSONTyped(json, false)
}

export function Registration200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Registration200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: Registration200ResponseDataFromJSON(json['data']),
  }
}

export function Registration200ResponseToJSON(
  value?: Registration200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: Registration200ResponseDataToJSON(value['data']),
  }
}
